import { Component, Input, OnInit } from '@angular/core';
import { EgiPage, EgiPagesSnapshot } from '@ervo/page-framework';
import { NavigationItemEntity } from '@/app/platform/platform-data/models/navigation-item.entity';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';

@Component({
    selector: 'navigation-item-conflicts-indicator[navigationItem][app]',
    templateUrl: './navigation-item-conflicts-indicator.component.html',
    styleUrls: ['./navigation-item-conflicts-indicator.component.scss'],
    standalone: false
})
export class NavigationItemConflictsIndicatorComponent implements OnInit {
  @Input() navigationItem: NavigationItemEntity;
  @Input() app: EgiAppEntity;

  constructor(private readonly egiPagesSnapshot: EgiPagesSnapshot) {}

  ngOnInit(): void {}

  get obsoleteClickTroughItems(): NavigationItemEntity[] {
    return this.navigationItem.children.filter(c =>
      this.navigationItem.obsoleteClickTroughPageIds.includes(c.pageComponentId)
    );
  }

  findMatchingEgiPage(id: string): EgiPage | undefined {
    return this.egiPagesSnapshot.pages.find(p => p.config.id === id);
  }
}
